import React from "react";
import ApprovalIntegrationPanel from "../../../../component/approvals/ApprovalIntegrationPanel";
import { financeApi } from "../../api/financeApi";

export default function ApprovalLinkTab() {
    return (
        <ApprovalIntegrationPanel
            loadApprovals={() => financeApi.getFinanceApprovals()}
            loadAccounts={() => financeApi.getBankAccounts()}
            financeConfirm={(approvalId, bankAccountId) => financeApi.finalApproveApproval(approvalId, bankAccountId)}
            infoBannerText="결재 → 재무 자동 연동: 대금지급요청·구매품의서 결재를 최종 지출확정하면 완료(실적)로 등록됩니다. 확정 시 입출금 계좌를 고르면 자금일보에도 자동 반영됩니다. 행을 클릭하면 상세 내용을 확인하고 처리할 수 있습니다."
        />
    );
}
